import { Employee } from '../../lib/interfaces/Employee.interface'

import {
  actionTypes,
  ActionTypes,
  EmployeesSetCurrentAction,
  EmployeeFetchSuccessAction,
  EmployeesFetchSuccessAction,
  EmployeeUpdateSuccessAction,
  EmployeeFetchFilesErrorAction,
  EmployeeFetchFilesSuccessAction,
  EmployeePostCommentSuccessAction,
  EmployeesSetCurrentSuccessAction,
  EmployeeFetchCommentsSuccessAction
} from './actions'

export interface EmployeesState {
  readonly isFetching: boolean
  readonly fetchFilesError?: any
  readonly isFetchingFiles: boolean
  readonly isUploadingFile: boolean
  readonly isPostingComment: boolean
  readonly isFetchingComments: boolean

  readonly employees?: Employee[]
  readonly currentEmployee?: Employee
  readonly employeeDetails?: Employee
}

export const initialState: EmployeesState = {
  isFetching: false,
  employees: undefined,
  isFetchingFiles: false,
  isUploadingFile: false,
  isPostingComment: false,
  isFetchingComments: false,
  currentEmployee: undefined,
  employeeDetails: undefined,
  fetchFilesError: undefined
}

export function reducer(state: EmployeesState = initialState, action: ActionTypes): EmployeesState {

  switch (action.type) {
    case actionTypes.EMPLOYEES_FETCH_LIST:
      return {
        ...state,
        employees: initialState.employees,
        isFetching: true,
      }

    case actionTypes.EMPLOYEES_FETCH_LIST_SUCCESS:
      return {
        ...state,
        employees: (action as EmployeesFetchSuccessAction).payload.employees,
        isFetching: false,
      }

    case actionTypes.EMPLOYEES_SET_CURRENT:
      return {
        ...state,
        currentEmployee: (action as EmployeesSetCurrentAction).payload.employee,
      }

    case actionTypes.EMPLOYEES_SET_CURRENT_SUCCESS:
        return {
          ...state,
          currentEmployee: (action as EmployeesSetCurrentSuccessAction).payload.employee,
        }

    case actionTypes.EMPLOYEE_FETCH:
      return {
        ...state,
        isFetching: true,
        employeeDetails: undefined
      }
    case actionTypes.EMPLOYEE_FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
        employeeDetails: undefined
      }
    case actionTypes.EMPLOYEE_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        employeeDetails: (action as EmployeeFetchSuccessAction).payload.employee
      }

    case actionTypes.EMPLOYEE_FETCH_FILES:
      return {
        ...state,
        isFetchingFiles: true,
        fetchFilesError: undefined
      }

    case actionTypes.EMPLOYEE_FETCH_FILES_FAILED: {
      const employeeFilesErrorAction = action as EmployeeFetchFilesErrorAction

      return {
        ...state,
        isFetchingFiles: false,
        fetchFilesError: employeeFilesErrorAction.payload.errorMessage
      }
    }

    case actionTypes.EMPLOYEE_FETCH_FILES_SUCCESS: {
      const employeeFilesAction = action as EmployeeFetchFilesSuccessAction

      const files = employeeFilesAction.payload.files
      const employeeId = employeeFilesAction.payload.employeeId

      let currentEmployee = state.currentEmployee
      if (currentEmployee && currentEmployee.id === employeeId) {
        currentEmployee = { ...state.currentEmployee } as Employee
        currentEmployee.files = files
      }

      let employeeDetails = state.employeeDetails
      if (employeeDetails && employeeDetails.id === employeeId) {
        employeeDetails = { ...state.employeeDetails } as Employee

        employeeDetails.files = files
      }

      return {
        ...state,
        currentEmployee,
        employeeDetails,
        isFetchingFiles: false,
        fetchFilesError: undefined
      }
    }

    case actionTypes.EMPLOYEE_UPLOAD_FILE:
      return { ...state, isUploadingFile: true }

    case actionTypes.EMPLOYEE_UPLOAD_FILE_SUCCESS:
      return { ...state, isUploadingFile: false }

    case actionTypes.EMPLOYEE_UPLOAD_FILE_FAILED:
      return { ...state, isUploadingFile: false }

    case actionTypes.EMPLOYEE_POST_COMMENT:
      return {
        ...state,
        isPostingComment: true
      }

    case actionTypes.EMPLOYEE_POST_COMMENT_SUCCESS: {
      const employeeDetails = { ...state.employeeDetails } as Employee

      const postCommentSuccessAction = action as EmployeePostCommentSuccessAction
      if (employeeDetails && employeeDetails.id === postCommentSuccessAction.payload.employeeId) {
        employeeDetails.comments = [ ...(employeeDetails.comments || []), postCommentSuccessAction.payload.comment ]
      }

      return {
        ...state,
        employeeDetails,
        isPostingComment: false
      }
    }

    case actionTypes.EMPLOYEE_POST_COMMENT_FAILED:
      return {
        ...state,
        isPostingComment: false
      }

    case actionTypes.EMPLOYEE_FETCH_COMMENTS:
      return { ...state, isFetchingComments: true }

    case actionTypes.EMPLOYEE_FETCH_COMMENTS_SUCCESS: {
      const employeeCommentsAction = action as EmployeeFetchCommentsSuccessAction

      const comments = employeeCommentsAction.payload.comments
      const employeeId = employeeCommentsAction.payload.employeeId

      let currentEmployee = state.currentEmployee
      if (currentEmployee && currentEmployee.id === employeeId) {
        currentEmployee = { ...state.currentEmployee } as Employee
        currentEmployee.comments = comments
      }

      let employeeDetails = state.employeeDetails
      if (employeeDetails && employeeDetails.id === employeeId) {
        employeeDetails = { ...state.employeeDetails } as Employee

        employeeDetails.comments = comments
      }

      return {
        ...state,
        currentEmployee,
        employeeDetails,
        isFetchingComments: false
      }
    }

    case actionTypes.EMPLOYEE_FETCH_COMMENTS_FAILED:
      return { ...state, isFetchingComments: true }

    case actionTypes.EMPLOYEE_UPDATE_SUCCESS: {
      const successAction = action as EmployeeUpdateSuccessAction
      const employee = successAction.payload.employee

      let currentEmployee = state.currentEmployee
      if (currentEmployee && currentEmployee.id === employee.id) {
        currentEmployee = {
          ...currentEmployee,
          ...employee
        }
      }

      let employeeDetails = state.employeeDetails
      if (employeeDetails && employeeDetails.id === employee.id) {
        employeeDetails = {
          ...employeeDetails,
          ...employee
        }
      }

      return {
        ...state,
        currentEmployee,
        employeeDetails
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/employees/reducer.ts